import types from "./types";

const initialState = {
  printStatus: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.PRINT_SHIPPING:
      return {
        ...state,
        printStatus: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
